import React from 'react'
import {Link} from 'react-router-dom'
import nynfcLogo from './../../img/nynfc_logo.svg'
import binamra from '../layout/Team/images/binamra_khadkha.jpg'


function Playerprofile(){
    return (
        <div className="container-fluid bg-white text-center player-profile-container">
            <div className="row player-profile-row">
                <img src={nynfcLogo} className="nynfc-profile-img" alt=""/>
                <h1>Binamra Khadkha</h1>
                <div className="d-flex flex-row justify-content-center social-media">
                    <div className="p-2">
                        <Link to="#">
                            <i className="fab fa-facebook fa-lg"></i>
                        </Link>
                    </div>
                    <div className="p-2">
                        <Link to="#">
                            <i className="fab fa-twitter fa-lg"></i>
                        </Link>
                    </div>
                    <div className="p-2">
                        <Link to="#">
                            <i className="fab fa-instagram fa-lg contact-icon-in"></i>
                        </Link>
                    </div>
                </div>  
            </div>
            <img src={binamra} alt="" className="img-fluid mb-4 player-profile-img" />  
            <div className="container player-info-container">
                <h1 className="player-information-h1">Player Information</h1>
                <div className="row player-info-row">
                    <div className="text-left player-info-col">
                        <div className="player-info-col-left">
                            <h5>Place of Birth</h5>
                            <h5>Age</h5>
                            <h5>Height</h5>
                            <h5>Weight</h5>
                            <h5>Position</h5>
                            <h5>Number</h5>
                            <h5>Current Team</h5>
                            <h5>Reside In</h5>
                            <h5>Membership Paid</h5>
                        </div>
                        <div className="player-info-col-right">
                            <h5>Nepal</h5>
                            <h5>32</h5>
                            <h5>6ft</h5>
                            <h5>180lbs</h5>
                            <h5>Forward</h5>
                            <h5>7</h5>
                            <h5>NYNFC</h5>
                            <h5>Boston</h5>
                            <h5><i class="fas fa-check fa-lg paid"></i></h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Playerprofile